import { ID } from '../../../../types/UtilityTypes'
import { eqString, getStructEq } from 'fp-ts/Eq'
import { SortDirection } from '../../../../constants/direction'
import { StatisticsRow } from '../../../../responses/statistics'

export interface OpenConfiguration {
    open: boolean,
    children?: Record<ID, OpenConfiguration>
}

export interface HideConfiguration {
    group: string,
    name: string,
}

export interface ColumnConfiguration<T> extends HideConfiguration {
    render: (data: StatisticsRow<T>) => number | string,
}

export interface SortConfiguration extends HideConfiguration {
    direction: SortDirection,
}

export const eqHide = getStructEq<HideConfiguration>({
    group: eqString,
    name: eqString,
})
